import { SignatureStatus, ThirdPartyType } from "@pepper/signature-react/dist/cjs/interfaces/signature";

export enum SignatureTypes {
  PEP = 'PEP',
  CER = 'CER',
  GAL = 'GAL',
  RUB = 'RUB',
}

export interface AuthToken {
  access_token: string;
}


export interface SignatureProps {
  signatureData: SignatureData;
  mode: string;
  aToken: AuthToken;
}

export interface Tag {
  key: string;
  value: string;
}

export interface CreateSignatureProps {
  putProps: SignatureProps;
}

export interface SignatureData {
  allowed_attempts: string;
  allowed_resends: string;
  communications: any;
  current_resends: string;
  flow: string;
  legal_checks: [];
  signature_id: string;
  signed_file: string;
  signer?: eSignatureCustomer;
  status: SignatureStatus;
  style?: SignatureStyle;
  tags: Tag[];
  texts: [];
  third_party: ThirdPartyType;
  third_party_auth: string;
  third_party_contract_id: string;
  third_party_domain_id: string;
  third_party_id: string;
  third_url: string;
  trace: any;
  url: string;
  url_callback: string;
  url_cancel: string;
  url_contract: string;
  url_ko: string;
  url_ok: string;
}
export interface CustomHeaderProps {
  firmaStyle: string;
  typeSignature: string;
}

export interface CustomFooterProps {
  firmaStyle: string | boolean;
  emitRecancel: (arg0: boolean) => void;
  texts: string | any;
  typeSignature: string;
}

export interface eSignatureDTO {
  allowed_attempts: string;
  allowed_resends: string;
  communications: any;
  current_resends: string;
  flow: string;
  legal_checks: [];
  signature_id: string;
  signed_file: string;
  customer?: eSignatureCustomer;
  signer?: eSignatureCustomer;
  status: string;
  style?: SignatureStyle;
  tags?: any;
  texts: [];
  third_party: string;
  third_party_auth: string;
  third_party_contract_id: string;
  third_party_domain_id: string;
  third_party_id: string;
  trace: any;
  url: string;
  url_callback: string;
  url_cancel: string;
  url_contract: string;
  url_ko: string;
  url_ok: string;
}

interface eSignatureCustomer {
  document_id: string;
  name: string;
  surname1: string;
  surname2: string;
  phone: string;
  email: string;
}

export enum SignatureStyle {
  ECO = "ECO",
  CEX = "CEX",
  TRO = "TRO",
  CHU = "CHU",
}